import React from "react";

export class ToastDetail {

    static build(messages: string[]): JSX.Element | null {
        if (messages !== null && messages.length > 0) {
            let toastDetails: any = [];
            messages.forEach((message, index) => {
                toastDetails.push(<span key={index} title={message} > {message} </span>);
                if (index !== messages.length - 1) {
                    toastDetails.push(<br key={'br' + index} > </br>);
                }
            });
            return <p style={{ "marginBottom": "0px", "overflow": "hidden", "textOverflow": "ellipsis" }}> {toastDetails} </p>;
        } else {
            return null;
        }
    }

}